import React from "react";
import cx from "classnames";

import s from "./FilterPill.module.scss";

export default function FilterPill({
	category,
	isSelected,
	className = "",
	onClick = () => {},
	children,
}) {
	return (
		<div
			className={cx(s.root, className, isSelected ? s.selected : "")}
			onClick={onClick}
		>
			{category && <p>{category.name}</p>}
			{children && <>{children}</>}
		</div>
	);
}
